import axios from "axios";
import { getAPIUrl } from "../utils/helper";

const axiosConfig = axios.create({
  baseURL: getAPIUrl(),
  // timeout: 10000,
});

export default axiosConfig;
